/**
 * Uses a RegExp to validate that the provided path is an app path https://regexr.com/6qn9r
 * @param path should be a clean path to not include the accountId or iframe
 * @returns boolean
 */
const isAppPath = (path: string): boolean => /^\/apps\/.+/g.test(path);

export default isAppPath;
